import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

// Data array for the 6 new cards, based on your image
const engineeringSolutions = [
  {
    title: 'Lab Scale Systems',
    description: 'Develop and test new processes at a manageable laboratory scale.',
    image: '/OIP.jpg', // Add your image path
    color: 'bg-gray-700', // Darker color from image
    link: '/solutions/lab-scale-systems'
  },
  {
    title: 'Pilot Plant',
    description: 'Validate your process and generate scale-up data with our custom pilot plants.',
    image: '/pp.webp', // Add your image path
    color: 'bg-blue-800', // Darker color from image
    link: '/solutions/pilot-plant'
  },
  {
    title: 'Distillation Plants',
    description: 'High-efficiency distillation and separation systems tailored to your needs.',
    image: '/dp.jpg', // Add your image path
    color: 'bg-blue-600', // Darker color from image
    link: '/solutions/distillation-plants'
  },
  {
    title: 'Reactors',
    description: 'Custom-designed chemical reactors for a wide range of applications.',
    image: '/reactor.jpg', // Add your image path
    color: 'bg-gray-600', // Darker color from image
    link: '/solutions/reactors'
  },
  {
    title: 'Demonstration Plants',
    description: 'Showcase your technology and produce market samples with a full-scale demo plant.',
    image: '/demonstration.jpg', // Add your image path
    color: 'bg-blue-700', // Darker color from image
    link: '/solutions/demonstration-plants'
  },
  {
    title: 'Process Development, Scale-up & Engineering Support',
    description: 'From concept to commissioning, our experts support your entire project lifecycle.',
    image: '/s.jpg', // Add your image path
    color: 'bg-indigo-800', // Darker color from image
    link: '/solutions/process-development'
  },
];


const Technology = () => {
  return (
    <section id="technology" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Heading */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Inside Hydrocawach Cavitation Systems
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
        </motion.div>

        {/* Row 1 - updated to summary only */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12"
        >
          {/* Video */}
          <div className="flex items-center justify-center">
            <video
              controls
              src="/vid3.mp4"
              className="rounded-lg shadow-lg w-full"
            />
          </div>

          {/* Summary Text + Button */}
          <div className="bg-blue-600 text-white p-8 rounded-lg shadow-lg flex flex-col justify-center">
            <h3 className="text-2xl font-semibold mb-4">
              Advanced Fluid Dynamics Technology
            </h3>
            <p className="text-lg leading-relaxed mb-4">
              Our cutting-edge Advanced Fluid Dynamics Technology-based treatment destroys harmful microbes,
              reduces BOD & COD, and clarifies water—without chemicals or filters.
            </p>
            <Link to="/technology/hydrodynamic-cavitation">
              <button className="bg-white text-blue-600 font-semibold px-4 py-2 rounded shadow hover:bg-blue-100">
                Learn More
              </button>
            </Link>
          </div>
        </motion.div>

        {/* --- NEW SECTION: 6-Card Grid --- */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-16">
          {engineeringSolutions.map((item, index) => (
            <Link to={item.link} key={item.title} className="group">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ y: -5 }}
                className="relative rounded-xl shadow-lg overflow-hidden h-60" // Fixed height for uniformity
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />

                {/* Hover Overlay (from Example 1) */}
                <div
                  className={`absolute inset-0 flex flex-col justify-center items-center text-center p-4 transition-all duration-500 ${item.color} bg-opacity-90 opacity-0 group-hover:opacity-100`}
                >
                  <h3 className="text-xl font-semibold text-white mb-2">
                    {item.title}
                  </h3>
                  <p className="text-white text-sm mb-4">{item.description}</p>
                  <span className="text-sm font-medium text-white underline">
                    Know more
                  </span>
                </div>

                {/* Initial Title Overlay (from Example 1) */}
                <div className="absolute inset-0 flex justify-center items-center p-4 bg-black bg-opacity-40 text-white text-xl font-bold transition-all duration-500 group-hover:opacity-0 text-center">
                  {item.title}
                </div>
              </motion.div>
            </Link>
          ))}
        </div>
        {/* --- END OF NEW SECTION --- */}

      </div>
    </section>
  );
};

export default Technology;